import { render } from "./ProductCardSkeleton.vue?vue&type=template&id=2e56c856&scoped=true"
import script from "./ProductCardSkeleton.vue?vue&type=script&lang=js"
export * from "./ProductCardSkeleton.vue?vue&type=script&lang=js"

import "./ProductCardSkeleton.vue?vue&type=style&index=0&id=2e56c856&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e56c856"]])

export default __exports__